export const GET_TYPE = 'GET_TYPE';
export const FETCH_BANKRANK_BEGIN = 'FETCH_BANKRANK_BEGIN';
export const FETCH_BANKRANK_SUCCESS = 'FETCH_BANKRANK_SUCCESS';
export const FETCH_BANKRANK_ERROR = 'FETCH_BANKRANK_ERROR';

export const RESET_BANKRANK = 'RESET_BANKRANK';